import React, { memo, useEffect, useRef, useState, Suspense, lazy } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import 'iframe-resizer';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';
import { Rates } from "rate-quotes";
import LeadCaptureForm from '../../components/LeadCaptureForm/';
import Classes from './index.module.css';
import styled from 'styled-components';
import AOS from "aos";
import MediaQuery from "react-responsive";
import "aos/dist/aos.css";
import Rectangleonimagemobile from '../../components/GameOnQuotes/images/Rectangleonimagemobile.png';
import Form from "../../components/ContactForm/index";
import Modal from "react-bootstrap/Modal";


const LoanOfficerHero = lazy(() => import('../../components/Hero/index'));
const BorrowerLeadForm = lazy(() => import('../../components/BorrowerLeadForm'));
const ResourcesMenu = lazy(() => import('../../components/ResourcesMenu'));
const FeaturesDiv = lazy(() => import('../../components/FeaturesDiv'));
const ServicesDiv = lazy(() => import('../../components/ServicesDiv'));
const TestimonialsDiv = lazy(() => import('../../components/Testimonials'));
const UserWayAccessibilityMenu = lazy(() => import('../../components/UserWayAccessibilityMenu'));

AOS.init();

const key = 'Home';

// Move the styled component definition outside of the component
const QuoteWrapper = styled.div`
  .react-multi-carousel-dot--active button {
    background: #083f88 !important;
    width: 25px !important;
    border-radius: 10px !important;
  }

  @media (max-width: 991.7px) {
    .react-multi-carousel-dot--active button {   
        margin-bottom:0rem;
    }
  }

  @media (min-width: 320px) and (max-width: 389.7px) {
    .react-multi-carousel-dot button {
      margin-right: 0px !important;
    }
    .react-multi-carousel-dot--active button {
      width: 17px !important;
    }
  }

  @media (min-width: 390px) and (max-width: 767.7px) {
    .react-multi-carousel-dot button {
      margin-right: 0px !important;
    }
    .react-multi-carousel-dot--active button {
      width: 17px !important;
    }
  }

  @media (min-width: 768px) and (max-width: 991.7px) {
    .react-multi-carousel-dot button {
      margin-right: 0.5px;
      width: 11px !important;
    }
    .react-multi-carousel-dot--active button {
      width: 13px !important;
    }
  }

  @media (min-width: 992px) and (max-width: 1100px) {
    .react-multi-carousel-dot button {
      margin-right: 2px !important;
    }
    .react-multi-carousel-dot--active button {
      width: 20px !important;
    }
  }
`;

const Homepage = ({ props }) => {

  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 991.9);
  const [showContactModal, setShowContactModal] = useState(false);
  const [showOtherComponents, setShowOtherComponents] = useState(false);

  const formRef = useRef(null);
  
  

  const handleOpenModal = () => {
    setShowContactModal(true);
  };

  const handleCloseModal = () => {
    setShowContactModal(false);
  };



  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth > 991.9);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const imgCDNURL = process.env.REACT_APP_LOWRATES_RESOURCES;

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.body.offsetHeight;
      const scrollPosition =
        window.scrollY ||
        window.pageYOffset ||
        document.documentElement.scrollTop;
      const maxScroll = documentHeight - windowHeight;
      const percentage = (scrollPosition / maxScroll) * 100;

      if (percentage > 50) {
        setShowOtherComponents(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const iframe = document.getElementById('iframeContactUs');

    if (iframe) {
      window.iFrameResize(
        {
          log: false,
          checkOrigin: false,
          autoResize: true,
          heightCalculationMethod: 'bodyScroll',
        },
        iframe
      );
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <article>
      <Helmet>
        <title>Choose LowRates | Experience Ai-Powered Fair and Fast Lending</title>
      </Helmet>

      <div className={Classes.bannerWrapper}>
        {/* Background Video */}
         <div className={Classes.videoBackground}>
          {/* <video autoPlay muted loop playsInline className={Classes.backgroundVideo}>
            <source
              src={isDesktop
                ? `https://resources.swmc.com/images/gameon-quotes/angelai-commecial.mp4`
                : `https://resources.swmc.com/images/gameon-quotes/angelai-commecial-mobile.mp4`}
              loading="eager"
              type="video/mp4"
            />
          </video> */}
        </div> 

        <Container className={Classes.bannercontainer}>
          <Row>
            <Col xs={12} sm={12} md={12} xl={12} lg={12} className={Classes.leftBannerDiv}>
              <Suspense fallback={<div>Loading...</div>}>
                {/* <MediaQuery maxWidth={991}>
                  <UserWayAccessibilityMenu color="white" width={50} height={50} />
                </MediaQuery> */}
              </Suspense>
              <Suspense fallback={<div>Loading...</div>}>
                <Rates leadSource="POPLEAD021"  />
              </Suspense>

              <h2 className={Classes.phonetext}>
                <a href='tel:+18558923806'>(855) 892-3806</a>
              </h2>
            </Col>

            {/* <Col xs={12} sm={12} md={5} xl={5} lg={5} className={Classes.rightBannerDiv}>
              <LoanOfficerHero
                loanOfficerData={loanOfficerData}
                handleOpenModal={handleOpenModal}
                commonContent={commonContent}
              />
              <Modal
                show={showContactModal}
                onHide={handleCloseModal}
                centered
                size="lg"
                backdrop="static"
                className="contact-form-modal"
              >
                <Modal.Body className="p-0">
                  <Form
                    mloData={mloData}
                    parentClass=".contact-form-modal"
                    node={true}
                    formRef={formRef}
                    handleCloseModal={handleCloseModal}
                    customDesigns={customDesigns}
                    commonContent={commonContent}
                  />
                </Modal.Body>
                </Modal>
            </Col> */}
          </Row> 
        </Container>
      </div>

      <div className={Classes.formContainer}>
        <Suspense fallback={<div>Loading...</div>}>
          <BorrowerLeadForm />
        </Suspense>
      </div>

      {showOtherComponents && (
        <>

      <Suspense fallback={<div>Loading...</div>}>
        <ResourcesMenu />
      </Suspense>

      <Suspense fallback={<div>Loading...</div>}>
        <FeaturesDiv />
      </Suspense>

      <Suspense fallback={<div>Loading...</div>}>
        <ServicesDiv />
      </Suspense>

      <QuoteWrapper>
        <Suspense fallback={<div>Loading...</div>}>
          <TestimonialsDiv />
        </Suspense>
      </QuoteWrapper>
      </>
      )}
    </article>
  );
};

export default Homepage;